import axios from "axios";
import { GET, POST } from '../_helpers/Fetch';
import { BillingApiUrl } from '../_constants/BillingAPI';

export const BillingApi = {
    GenerateBillingManual,
    GetAction,
    ViewBillingReview,
    ApproveBilling,
    DownloadBillingFile
};

async function GenerateBillingManual() {
    return axios.get(BillingApiUrl.BILLING_GENERATE_MANUAL, { responseType: "blob" });
}

async function GetAction() {
    try {
        const Response = await GET(BillingApiUrl.BILLING_GET_GENERATE_MANUAL_ACTION);
        return Response; // Returns: GMBSBillingGenerateManualActionDto
    } catch (err) {
        return null;
    }
}

async function ViewBillingReview() {
    return axios.get(BillingApiUrl.BILLING_REVIEW_VIEW); // Returns: ApiResponse<BillingSummaryDto>
}

async function ApproveBilling(approveBillingDto) {
    return axios.post(BillingApiUrl.BILLING_REVIEW_APPROVE, approveBillingDto); // Returns: ApiResponse<BillingSummaryDto>
}

async function DownloadBillingFile(billingGenerateDto) {
    var downloadUrl = BillingApiUrl.BILLING_FILE_DOWNLOAD
        + "?month=" + billingGenerateDto.month
        + "&year=" + billingGenerateDto.year;

    return axios.get(downloadUrl, { responseType: "blob" });
}
